import { useTranslation } from "react-i18next";
import {
	ThemeColorVariable,
	ThemeRadiusVariable,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library.base-ui.theme";
import { Flex } from "@caspeco/casper-ui-library.components.flex";
import { Image } from "@caspeco/casper-ui-library.components.image";
import { Box } from "@caspeco/casper-ui-library.components.box";
import { Text } from "@caspeco/casper-ui-library.components.text";
import { AspectRatio } from "types/ui";
import { SubArticle } from "types/article";
import Price from "components/price/Price";

interface ISubArticleLabel {
	item: SubArticle;
	isChecked: boolean;
	isDisabled: boolean;
}
export function SubArticleLabel({ item, isChecked, isDisabled }: ISubArticleLabel) {
	const { t } = useTranslation();
	const { imageMap, name, inHousePriceIncludingVat, takeAwayPriceIncludingVat } = item;

	const imgSize = "48px";
	const priceTextColor = isChecked ? ThemeColorVariable.OnSurface : ThemeColorVariable.OnSurfaceSubdued;
	const nameTextColor = isDisabled ? ThemeColorVariable.OnSurfaceSubdued : ThemeColorVariable.OnSurface;

	return (
		<Flex justifyContent="space-between" w="100%" alignItems="center">
			<Flex gap={ThemeSpaceVariable.Small} alignItems="center">
				{imageMap.hasImage(AspectRatio.OneByOne) && (
					<Image
						src={imageMap.withSizeQuery(AspectRatio.OneByOne, "s")}
						alt={t("misc_picture_of_x", { 0: name })}
						borderRadius={ThemeRadiusVariable.Small}
						h={imgSize}
						w={imgSize}
						minH={imgSize}
						minW={imgSize}
						loading="lazy"
						fallback={
							<Box
								h={imgSize}
								w={imgSize}
								minH={imgSize}
								minW={imgSize}
								borderRadius={ThemeRadiusVariable.Small}
								bg={ThemeColorVariable.SurfaceDisabled}
							/>
						}
					/>
				)}
				<Text noOfLines={2} color={nameTextColor}>
					{name}
				</Text>
			</Flex>
			<Price
				prepend="+"
				color={priceTextColor}
				inHousePrice={inHousePriceIncludingVat}
				takeAwayPrice={takeAwayPriceIncludingVat}
			/>
		</Flex>
	);
}
